import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DBConfigService {
    constructor(private http: HttpClient) {}

    getConfig(): Observable<{ orgId: string } | null> {
        return this.http.get<{ orgId: string }>('assets/sprintpay/config.json').pipe(catchError(() => of(null)));
    }
}
